import { createColumnHelper, getCoreRowModel } from "@tanstack/react-table";
import { cloneDeep } from "lodash";
import Cell from "./Cell";

/** @param {any[]} columns */
const createColumnDefinitionFrom = (columns) => {
  if(columns.length === 0) {
    return [];
  }

  const columnHelper = createColumnHelper();

  const columnConfig = columns.map((column) => {
    return columnHelper.accessor(column.accessorKey, {
      id: column.id,
      cell: column.cell || Cell,
      header: column.header || Cell,
      meta: column.meta,
    });

  });

  return columnConfig;
}

export default class ReactTableConfigBuilder {
  constructor(data, columns) {
    this.tableConfig = {
      getCoreRowModel: getCoreRowModel()
    };
    this.data = data;
    this.columns = columns;
  }

  _setData() {
    this.tableConfig.data = this.data;
  }

  _setColumns() {
    this.tableConfig.columns = createColumnDefinitionFrom(this.columns);
  }

  /** @param {string[]} pinnedColumns */
  setPinnedColumns(pinnedColumns) {
    if (pinnedColumns.length === 0) {
      return;
    }

    this.tableConfig.initialState = {
      columnPinning: {
        left: pinnedColumns,
      },
    };
  }

  /** @returns {Object} */
  build() {
    if(!Array.isArray(this.data) || !Array.isArray(this.columns)) {
      throw new Error("Data and columns must be an array");
    }

    if (this.columns.length === 0) {
      throw new Error ("columns must be set before building the table config");
    }

    this._setData();
    this._setColumns()
    return cloneDeep(this.tableConfig);
  }
}
